import React, { Fragment } from 'react';

export const HEARTBEAT_PERIOD               = 60000;

export const PRODUCT_NAME                   = 'Messenger';
export const PRODUCT_ICON_ROUTE             = '/favicon-2018.png';

export const PUBLIC_CHANNEL                 = 'PUBLIC_CHANNEL';
export const PUBLIC_CHANNELS                = 'public channels';
export const PUBLIC_CHANNEL_LABEL           = 'Public';
export const PRIVATE_CHANNEL                = 'PRIVATE_CHANNEL';
export const PRIVATE_CHANNEL_LABEL          = 'Private';
export const DIRECT_MESSAGE                 = 'DIRECT_MESSAGE';
export const CHANNELS                       = 'Channels';
export const USER                           = 'USER';
export const USERS                          = 'users';
export const INVITE_USERS                   = 'Invite Users';

export const DIRECTORY                      = 'Directory';
export const BROWSE_DIRECTORY               = 'Browse Directory';

export const MESSAGE                        = 'MESSAGE';
export const ATTACHMENT                     = 'ATTACHMENT';

// A message to self is just 1 user and a typical direct message includes 2 users. A group message would have 3 or more users
export const MESSAGE_LIMIT_SIZE             = 50;
export const MESSAGE_CHARACTER_LIMIT        = 4096; // WARNING if you change this you also need to change the database column size limit

export const TYPING_BEGIN                   = 1000; // Milliseconds
export const TYPING_COMPLETE                = 1250; // Milliseconds

export const MAX_VIDEOS_IN_MEMORY           = 5;

export const CREATE_DM                      = 'Create Direct Message';
export const CREATE_CHANNEL                 = 'Create Channel';
export const DIRECT_MESSAGES                = 'Direct Messages';
export const DIRECT_MESSAGE_TYPE            = 'direct-message';
export const CHANNEL_TYPE                   = 'channel';

export const USER_SIZE_SMALL                = 'small';

export const FILTER_ALL                     = 'all';
export const FILTER_CHANNELS                = 'channels';
export const FILTER_PEOPLE                  = 'people';

/* System Message Types*/
export const ADDED_USER_TO_CHANNEL = 'ADDED_USER_TO_CHANNEL';
export const USER_JOINED_CHANNEL = 'USER_JOINED_CHANNEL';
export const USER_LEFT_CHANNEL = 'USER_LEFT_CHANNEL';
export const BEGINNING_OF_CHANNEL = 'BEGINNING_OF_CHANNEL';

// Api Response timeouts
export const DEFAULT_TIMEOUT                = 5000;  // 5 seconds
export const GET_ATTACHMENT_TIMEOUT         = 30000; // 30 seconds
export const GET_IDENTITY_TIMEOUT           = 3000;
export const APP_START_DATA_TIMEOUT         = 2000;

export const TIMEOUT_ERROR_REASON           = 'Timeout';

export const MAX_MINUTES_TO_CHAIN_MESSAGES  = 5;

// User statuses
export const USER_STATUS_ONLINE             = 'ONLINE';
export const USER_STATUS_OFFLINE            = 'OFFLINE';
export const USER_STATUS_AWAY               = 'AWAY';
export const USER_STATUS_IDLE               = 'IDLE';

// Leave Chat Constants
export const LEAVE_CHAT_ABLE_TO_REJOIN_MSG = 'You will be able to re-enter it again.';
export const LEAVE_CHAT_UNABLE_TO_REJOIN_MSG = 'You will not be able to access this channel again unless you are invited to it.';

// React Router Constants
export const HISTORY_POP                    = 'POP';

// Action/Response Type suffixes
export const CONFIRM_SUFFIX                 = 'CONFIRM';
export const SUCCESS_SUFFIX                 = 'SUCCESS';
export const FAIL_SUFFIX                    = 'FAIL';
export const PENDING_SUFFIX                 = 'PENDING';
export const TIMEOUT_SUFFIX                 = 'TIMEOUT';

// Local Storage for Auth
export const AUTH                           = 'auth';
export const LOGGING_OUT                    = 'loggingOut';
export const LOGGED_IN                      = 'loggedIn';

/** ***************************************************************************************************/

// Landing Page Constants
export const INTRO_CHANNELS                   = <Fragment>Channels are areas where communications are centered around a particular topic, such as <strong><em>billing</em></strong> or <strong><em>nurses</em></strong>.</Fragment>;
export const INTRO_DM                         = 'A direct message is a private message between one or multiple people that others are not able to view or join.';
export const INTRO_DIRECTORY                  = groupStats => <Fragment>Your organization currently has {groupStats} that you can find in the directory.</Fragment>;
export const GREETING                         = `Welcome to ${PRODUCT_NAME}, `;
export const INTRO_SUBHEADING                 = 'What would you like to do next?';
export const UPDOX_HELP_CTA                   = 'View more in the Updox Knowledge Base';
export const FEATURES_HEADING                 = 'Tips & Tricks';
export const FEATURE_SEND_TO_INBOX_HEADING    = 'Send Messages To Your Inbox';
export const FEATURE_SEND_TO_INBOX_CONTENT_1  = 'In any chat, click on the';
export const FEATURE_SEND_TO_INBOX_CONTENT_2  = 'icon in the top-right to select messages that you can then send directly to your inbox.';

// HTTP Status
export const HTTP_STATUS_REQUEST_TIMEOUT      = 408;


/*
 * Inbox-Messenger constants
 */
export const INBOX_MESSENGER_LOGIN = 'inbox-chat-login';
